import React from "react";
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthentication } from "../hooks/useAuthentication";

const AuthGuard = () => {
    const { isAuthenticated } = useAuthentication();

    return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
};

export default AuthGuard;